export function nextLabelRemap({
  classNames,
  deleted,
  mapping,
  expectedClassOrder,
  inheritSingleTarget,
}: {
  classNames: string[];
  deleted: string[];
  mapping: Record<string, string>;
  expectedClassOrder: string[];
  inheritSingleTarget: boolean;
}): { deleted: string[]; mapping: Record<string, string>; expectedClassOrder: string[] } {
  const present = new Set(classNames);
  const nextMapping: Record<string, string> = {};
  Object.entries(mapping).forEach(([key, value]) => {
    if (present.has(key) && value && value !== key) nextMapping[key] = value;
  });
  const nextDeleted = deleted.filter((name) => present.has(name));
  const included = classNames.filter((name) => !nextDeleted.includes(name));
  const unmapped = included.filter((name) => !nextMapping[name]);
  if (
    inheritSingleTarget
    && unmapped.length === 1
    && expectedClassOrder.length === 1
    && unmapped[0] !== expectedClassOrder[0]
  ) {
    nextMapping[unmapped[0]] = expectedClassOrder[0];
  }
  const mapped = included.map((name) => nextMapping[name] || name);
  const unique = mapped.filter((name, index) => mapped.indexOf(name) === index);
  const still = expectedClassOrder.filter((name) => unique.includes(name));
  const added = unique.filter((name) => !still.includes(name));
  return {
    deleted: nextDeleted,
    mapping: nextMapping,
    expectedClassOrder: still.length > 0 ? [...still, ...added] : unique,
  };
}
